import React, { useState, useEffect } from "react";
import CustomFilters from "../../core/custom-filters";
import SiAutocomplete from "../../core/si-autocomplete";
import { HTTP_METHODS, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";

const OemNameFilters = ({ loadData, oems }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");

  const applyFilters = (filters) => {
    const payload = {};
    if (Object.keys(filters).length) {
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else {
          payload[key] = filters[key];
        }
      }

      loadData({
        ...payload,
      });
    } else {
      loadData({
        ...payload,
      });
    }
  };

  const filterTypes = [{ label: "Filter Oem", value: "name" }];
  const renderFilterInput = () => {
    switch (filterType) {
      case "name":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={oems?.map((ele) => ({
              label: ele.name,
              value: ele.name,
            }))}
            placeholder="Search Oem"
          />
        );

      default:
        return null;
    }
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default OemNameFilters;
